// RTT tablet product media runtime style 20260703 start
// RTT tablet ATC cache-bust 20260705-breathing
(() => {
  const STYLE_ID = 'rtt-tablet-product-media-runtime-style';
  const css = `
@media screen and (min-width: 750px) and (max-width: 989px) {
  .product .product__media-wrapper,
  .product .product__media-list,
  .product .product__media-list .product__media-item {
    height: min(74vw, 56.5rem, calc(100vh - 44.5rem)) !important;
    max-height: none !important;
    min-height: 0 !important;
  }

  .product .product-media-container.global-media-settings,
  .product .product__media,
  .product .rtt-dawn-single-media-viewer {
    aspect-ratio: auto !important;
    height: 100% !important;
    max-height: none !important;
    min-height: 0 !important;
  }

  .product .product__media img,
  .product .rtt-dawn-single-media-viewer__image {
    height: 100% !important;
    max-height: none !important;
  }

  .product .product__info-wrapper {
    max-width: min(54rem, calc(100vw - 10rem)) !important;
    padding-inline: 0 !important;
  }

  .product .product__info-container {
    max-width: 54rem !important;
    margin-inline: auto !important;
    padding-top: 2rem !important;
    width: 100% !important;
  }

  .product .product__info-container product-form.product-form {
    margin-top: 1.5rem !important;
  }
}

@media screen and (min-width: 750px) and (max-width: 989px) and (max-height: 950px) {
  .product .product__media-wrapper {
    margin-inline: auto !important;
    max-width: min(54rem, calc(100vw - 10rem)) !important;
    width: min(54rem, calc(100vw - 10rem)) !important;
  }

  .product .product__media-list,
  .product .product__media-list .product__media-item,
  .product .product-media-container.global-media-settings,
  .product .product__media,
  .product .rtt-dawn-single-media-viewer {
    max-width: 100% !important;
    width: 100% !important;
  }
}`;
  const install = () => {
    if (!document.querySelector('.product')) return;
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    document.head.appendChild(style);
  };
  const syncTabletMediaHeight = () => {
    const matches = window.matchMedia('(min-width: 750px) and (max-width: 989px)').matches;
    const shortTablet = window.matchMedia('(min-width: 750px) and (max-width: 989px) and (max-height: 950px)').matches;
    const fixedHeightElements = document.querySelectorAll(
      '.product .product__media-wrapper, .product .product__media-list, .product .product__media-list .product__media-item'
    );
    const fillHeightElements = document.querySelectorAll(
      '.product .product-media-container.global-media-settings, .product .product__media, .product .rtt-dawn-single-media-viewer'
    );
    const mediaImages = document.querySelectorAll(
      '.product .product__media img, .product .rtt-dawn-single-media-viewer__image'
    );

    fixedHeightElements.forEach((element) => {
      if (matches) {
        element.style.setProperty('height', 'min(74vw, 56.5rem, calc(100vh - 44.5rem))', 'important');
        element.style.setProperty('max-height', 'none', 'important');
        element.style.setProperty('min-height', '0', 'important');
        element.style.setProperty('overflow', 'hidden', 'important');
        if (shortTablet && element.matches('.product .product__media-wrapper')) {
          element.style.setProperty('width', 'min(54rem, calc(100vw - 10rem))', 'important');
          element.style.setProperty('max-width', 'min(54rem, calc(100vw - 10rem))', 'important');
          element.style.setProperty('margin-inline', 'auto', 'important');
        } else if (element.matches('.product .product__media-wrapper')) {
          element.style.removeProperty('width');
          element.style.removeProperty('max-width');
          element.style.removeProperty('margin-inline');
        }
      } else {
        element.style.removeProperty('height');
        element.style.removeProperty('max-height');
        element.style.removeProperty('min-height');
        element.style.removeProperty('overflow');
        if (element.matches('.product .product__media-wrapper')) {
          element.style.removeProperty('width');
          element.style.removeProperty('max-width');
          element.style.removeProperty('margin-inline');
        }
      }
    });
    fillHeightElements.forEach((element) => {
      if (matches) {
        element.style.setProperty('aspect-ratio', 'auto', 'important');
        element.style.setProperty('height', '100%', 'important');
        element.style.setProperty('max-height', 'none', 'important');
        element.style.setProperty('min-height', '0', 'important');
        if (shortTablet) {
          element.style.setProperty('width', '100%', 'important');
          element.style.setProperty('max-width', '100%', 'important');
        } else {
          element.style.removeProperty('width');
          element.style.removeProperty('max-width');
        }
      } else {
        element.style.removeProperty('aspect-ratio');
        element.style.removeProperty('height');
        element.style.removeProperty('max-height');
        element.style.removeProperty('min-height');
        element.style.removeProperty('width');
        element.style.removeProperty('max-width');
      }
    });
    mediaImages.forEach((element) => {
      if (matches) {
        element.style.setProperty('height', '100%', 'important');
        element.style.setProperty('max-height', 'none', 'important');
      } else {
        element.style.removeProperty('height');
        element.style.removeProperty('max-height');
      }
    });
  };
  install();
  syncTabletMediaHeight();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install, { once: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncTabletMediaHeight, { once: true });
  window.addEventListener('resize', syncTabletMediaHeight, { passive: true });
  document.addEventListener('shopify:section:load', syncTabletMediaHeight);
  const observer = new MutationObserver(syncTabletMediaHeight);
  if (document.body) observer.observe(document.body, { childList: true, subtree: true });
  else document.addEventListener('DOMContentLoaded', () => observer.observe(document.body, { childList: true, subtree: true }), { once: true });
  [50, 150, 350, 750, 1500, 2500].forEach((delay) => setTimeout(syncTabletMediaHeight, delay));
})();
// RTT tablet product media runtime style 20260703 end

if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const sourceProductInfo = html.querySelector(selector);
          const variant = this.getSelectedVariant(sourceProductInfo);
          this.variantSelectors?.resolvePendingSelectPromise(variant, this.getVariantSelects(sourceProductInfo));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
            this.variantSelectors?.rejectPendingSelectPromise(error);
          });
      }

      parseJsonScript(parent, selector) {
        try {
          return JSON.parse(parent?.querySelector(selector)?.textContent);
        } catch {
          return null;
        }
      }

      getVariantSelects(queryRoot) {
        return queryRoot?.querySelector('variant-selects');
      }

      getSelectedVariant(productInfoNode) {
        return this.parseJsonScript(this.getVariantSelects(productInfoNode), '[data-selected-variant]');
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const sourceVariantSelects = this.getVariantSelects(html);
          const variant = this.getSelectedVariant(html);

          // Resolve product:select promise before updateOptionValues replaces the variant-selects DOM element
          this.variantSelectors?.resolvePendingSelectPromise(variant, sourceVariantSelects);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      async updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        // RTT product media in-place decoded swap start
        // RTT product-info cache refresh 2026-07-02
        const mediaGallery = this.querySelector('media-gallery');
        const currentImage = mediaGallery?.querySelector('.product__media-item.is-active img, .product__media img');
        const mediaGalleryDestination = html.querySelector('media-gallery ul');
        const mediaGalleryDestinationItems = Array.from(
          mediaGalleryDestination?.querySelectorAll('li[data-media-id]') || []
        );
        const targetMediaId = `${this.dataset.section}-${variantFeaturedMediaId}`;
        const targetItem = mediaGalleryDestinationItems.find(
          (item) => item.dataset.mediaId === targetMediaId || item.dataset.mediaId.endsWith(`-${variantFeaturedMediaId}`)
        );
        const targetImage = targetItem?.querySelector('img');

        if (currentImage && targetImage) {
          const preload = new Image();
          preload.decoding = 'async';
          preload.fetchPriority = 'high';
          if (targetImage.sizes) preload.sizes = targetImage.sizes;
          if (targetImage.srcset) preload.srcset = targetImage.srcset;
          preload.src = targetImage.currentSrc || targetImage.src;

          try {
            if (preload.decode) await preload.decode();
            else if (!preload.complete) {
              await new Promise((resolve) => {
                preload.addEventListener('load', resolve, { once: true });
                preload.addEventListener('error', resolve, { once: true });
              });
            }
            await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
          } catch (_error) {}

          ['src', 'srcset', 'sizes', 'alt', 'width', 'height'].forEach((attribute) => {
            const value = targetImage.getAttribute(attribute);
            if (value == null) currentImage.removeAttribute(attribute);
            else currentImage.setAttribute(attribute, value);
          });

          const currentItem = currentImage.closest('li[data-media-id]');
          if (currentItem && targetItem?.dataset?.mediaId) {
            currentItem.dataset.mediaId = targetItem.dataset.mediaId;
            currentItem.id = targetItem.id || currentItem.id;
          }

          const liveRegion = mediaGallery?.querySelector('[id^="GalleryStatus"]');
          if (liveRegion) {
            liveRegion.setAttribute('aria-hidden', true);
            liveRegion.textContent = '';
          }

          const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
          const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
          if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
          return;
        }
        // RTT product media in-place decoded swap end

        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
            if (selector === '.quantity__label') {
              const updatedAriaLabelledBy = updated.getAttribute('aria-labelledby');
              if (updatedAriaLabelledBy) {
                current.setAttribute('aria-labelledby', updatedAriaLabelledBy);
                // Update the referenced visually hidden element
                const labelId = updatedAriaLabelledBy;
                const currentHiddenLabel = document.getElementById(labelId);
                const updatedHiddenLabel = html.getElementById(labelId);
                if (currentHiddenLabel && updatedHiddenLabel) {
                  currentHiddenLabel.textContent = updatedHiddenLabel.textContent;
                }
              }
            }
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
